module.exports = __webpack_public_path__ + "static/brownsafarimain-cc01d395c90738631df4d782c41e0e89.png";